module.exports = __webpack_public_path__ + "static/media/java.272403c7.png";